/*
Helper used to build an array from an internal list of components;
includes all components in the list except the one passed in.

Examples:

<ReactiveList
    componentId="ResultList"
    react={{ and: reactArray("ResultList") }}
  .../>
Since the name passed in isn't in the list this will make the ReactiveList 
listen to ALL the components in the list 

<MultiDropdownList
     componentId="RegionNameSearch"
     react={{ and: reactArray("RegionNameSearch") }}
  .../>
will make the MultiDropdownList listen to all other components but not itself 
*/


function reactArray(componentId) {
    let arr = ["FreetextSearch",
        "SorIdController",
        "EntityTypeNameSearch",
        "OrganizationalLevelNameSearch", 
        "TodataSearch",
        "SpecialityListSearch",
        "SorTypeSearch",
        "EanLocationCodeSearch",
        "ShakIdSearch",
        "PostalAddressSearch",
        "RegionNameSearch",
        "PostalMunicipalityNameSearch",
        "PostalCodeRangeStart",
        "PostalCodeRangeEnd",
        "ValidFromSearch",
        "EanRegionNameSearch", 
        "ModifiedDateSearch",
        "CodeSystemSearch",
        "CodeSystemSupplierName",
        "CommunicationSupplierSearch",
        "EdiFactSearch",
        "InstitutionOwnerEntityNameSearch",  
    ]
    const index = arr.indexOf(componentId)
    if(index > -1 ){
        arr.splice(index, 1)
    }
    return arr
} 
export default reactArray 